"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Row = exports.Col = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = require("../../utils/classify");
var _qa = require("../../utils/qa");
var _GridModule = _interopRequireDefault(require("./Grid.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const GRID_SYSTEM_MAP = {
  small: 24,
  medium: 12,
  large: 6,
  autoFill: 'auto-fill',
  autoFit: 'auto-fit'
};
const Row = _ref => {
  let {
    className,
    children,
    gridType = 'medium',
    repeatTracks = '1fr',
    testId
  } = _ref;
  const gridRepeatCount = GRID_SYSTEM_MAP[gridType];
  let columnSpanCount = 0;
  let lastChildColCount = 0;
  const childrenWithProps = React.Children.map(children, child => {
    if (/*#__PURE__*/React.isValidElement(child)) {
      const {
        span = 1,
        offset = 0
      } = child.props;
      if (span < 1) {
        console.error(`span can not be less than one`);
        return;
      }
      if (offset < 0) {
        console.error(`offset can not be negative`);
        return;
      }
      lastChildColCount = columnSpanCount;
      columnSpanCount = lastChildColCount + offset + span;
      let gridColumnStart = 0;
      // const gridColumnEnd: number | string = 0;

      if (gridType === 'autoFill' || gridType === 'autoFit') {
        gridColumnStart = 'auto';
        return /*#__PURE__*/React.cloneElement(child, {
          gridColumnStart,
          gridColumnEnd: `span ${span}`
        });
      } else if (typeof gridRepeatCount === 'number' && columnSpanCount <= gridRepeatCount) {
        gridColumnStart = lastChildColCount + offset + 1;
        return /*#__PURE__*/React.cloneElement(child, {
          gridColumnStart,
          gridColumnEnd: `span ${span}`
        });
      } else {
        console.error(`number of column exceed ${gridRepeatCount}`);
      }
    }
    return child;
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'row'
    }),
    className: (0, _classify.classify)(_GridModule.default.gridRow, className),
    style: {
      '--grid-repeat-count': gridRepeatCount,
      '--repeat-tracks': repeatTracks
    },
    children: childrenWithProps
  });
};
exports.Row = Row;
const Col = _ref2 => {
  let {
    className,
    children,
    gridColumnStart,
    gridColumnEnd,
    testId
  } = _ref2;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'col'
    }),
    className: (0, _classify.classify)(_GridModule.default.gridColumn, className),
    style: {
      '--grid-column-start': gridColumnStart || 0,
      '--grid-column-end': gridColumnEnd || 0
    },
    children: children
  });
};
exports.Col = Col;